const $ = require('jquery')

window.jQuery = $

const APP = require('APP')

APP.isProvider = true
const trans = require('trans')
const numbers = require('numbers')

const SimpleDialog = require('UI/SimpleDialog')
const GameModel = require('Models/Game')
const GamePlayHtml5View = require('Views/GamePlay/GamePlayHtml5View')

const gamePlayMoneyFormat = APP.config.flashvars.gamePlayMoneyFormat || APP.gamePlayMoneyFormat
numbers.setFormat(APP.moneyTemplate, APP.moneyTemplateNr, APP.denomination, gamePlayMoneyFormat)

const runGame = function runGame() {
  const gameBox = document.getElementById('gameBox')
  const game = new GameModel(APP.gameObj)
  const { forFun } = APP.config.flashvars

  APP.gameInitData = { config: APP.config }

  const gamePlayView = new GamePlayHtml5View({ gameModel: game, forFun, padding: 0 })

  // focusing iFrame on clicking document
  document.addEventListener('click', () => {
    // eslint-disable-next-line no-restricted-globals
    parent.postMessage('focusIframe', '*')
  })

  gameBox.appendChild(gamePlayView.el)

  window.addEventListener('message', (event) => {
    try {
      if (event.data && event.data === 'getScreenshot') {
        if (gamePlayView && gamePlayView.getScreenshot) {
          gamePlayView.getScreenshot((imgData) => {
            // eslint-disable-next-line no-console
            console.log(imgData)
          })
        }
      } else if (event.data && event.data === 'exit') {
        // eslint-disable-next-line no-console
        console.log('sending')
        closeFn()
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e)
    }
  })
}

let closeMsgSend = false
const closeFn = function closeFn() {
  if (!closeMsgSend) {
    closeMsgSend = true
  }
}

/**
 * SIMPLE routing
 */
if (APP.pageRoute === 'api_game_play') {
  // desktop chrome / ff / android chrome
  window.addEventListener('beforeunload', closeFn)
  // mobile android / iOS
  window.addEventListener('unload', closeFn)
  // iOS
  window.addEventListener('pagehide', closeFn)

  if (APP.gameObj.error) {
    SimpleDialog.message(trans('Message'), APP.gameObj.error, () => {
      try {
        // eslint-disable-next-line no-restricted-globals
        if (parent && parent.postMessage) {
          // eslint-disable-next-line no-restricted-globals
          parent.postMessage('closeGame', '*')
        }
        window.closeGame()
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err)
      }
    })
  } else {
    runGame()
  }
}
